import React from "react";
import { CircularProgress } from "@mui/material";
import { useSite } from "hooks/use-site";

type BrandingLogoProps = {
  width?: number | string;
  height?: number;
};

const BrandingLogo: React.FC<BrandingLogoProps> = ({ width = 200, height }) => {
  const { logo, isLogoLoading } = useSite();

  if (isLogoLoading) {
    return <CircularProgress size={32} aria-label="Loading logo" />;
  }

  if (!logo) {
    return null;
  }

  return <img src={logo} alt="logo" width={width} height={height} />;
};

export default BrandingLogo;
